import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_3 = { class: "card-body p-0" }
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 p-4" }
const _hoisted_5 = { class: "default-table-area style-two default-table-width" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table align-middle" }
const _hoisted_8 = {
  key: 0,
  scope: "col"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "text-body" }
const _hoisted_12 = { class: "mb-0 fs-14 fw-medium" }
const _hoisted_13 = { class: "text-body" }
const _hoisted_14 = { class: "text-body" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "d-flex align-items-center gap-1" }
const _hoisted_17 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: "Customers",
      subTitle: "Management"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            class: "position-relative table-src-form me-0",
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              placeholder: "Search customers...",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event))
            }, null, 512), [
              [_vModelText, _ctx.searchQuery]
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("i", { class: "material-symbols-outlined position-absolute top-50 start-0 translate-middle-y" }, "search", -1))
          ], 32),
          _createVNode(_component_RouterLink, {
            to: "/customers/create",
            class: "btn btn-outline-primary py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3 hover-bg"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("span", { class: "py-sm-1 d-block" }, [
                _createElementVNode("i", { class: "ri-add-line d-none d-sm-inline-block me-1" }),
                _createElementVNode("span", null, "Add New Customer")
              ], -1)
            ])),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _cache[4] || (_cache[4] = _createElementVNode("th", { scope: "col" }, "ID", -1)),
                  _cache[5] || (_cache[5] = _createElementVNode("th", { scope: "col" }, "Phone Number", -1)),
                  _cache[6] || (_cache[6] = _createElementVNode("th", { scope: "col" }, "Name", -1)),
                  _cache[7] || (_cache[7] = _createElementVNode("th", { scope: "col" }, "Free Tokens", -1)),
                  _cache[8] || (_cache[8] = _createElementVNode("th", { scope: "col" }, "Created At", -1)),
                  (_ctx.isSuperAdmin)
                    ? (_openBlock(), _createElementBlock("th", _hoisted_8, "Actions"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_9, _cache[9] || (_cache[9] = [
                      _createElementVNode("td", {
                        colspan: "6",
                        class: "text-center py-4"
                      }, "Loading...", -1)
                    ])))
                  : (_ctx.filteredCustomers.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_10, _cache[10] || (_cache[10] = [
                        _createElementVNode("td", {
                          colspan: "6",
                          class: "text-center py-4"
                        }, "No customers found.", -1)
                      ])))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.filteredCustomers, (customer) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: customer.customer_id
                        }, [
                          _createElementVNode("td", null, "#" + _toDisplayString(customer.customer_id), 1),
                          _createElementVNode("td", _hoisted_11, _toDisplayString(customer.phone_number), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("h6", _hoisted_12, _toDisplayString(customer.name || '-'), 1)
                          ]),
                          _createElementVNode("td", _hoisted_13, _toDisplayString(customer.free_tokens), 1),
                          _createElementVNode("td", _hoisted_14, _toDisplayString(new Date(customer.created_at).toLocaleDateString()), 1),
                          (_ctx.isSuperAdmin)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                  _createVNode(_component_RouterLink, {
                                    to: `/customers/${customer.customer_id}/edit`,
                                    class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                                  }, {
                                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, "edit", -1)
                                    ])),
                                    _: 2
                                  }, 1032, ["to"]),
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (_ctx.deleteCustomer(customer.customer_id)),
                                    class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                                  }, _cache[12] || (_cache[12] = [
                                    _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, "delete", -1)
                                  ]), 8, _hoisted_17)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}